import React from 'react'
import PropTypes from 'prop-types'

// import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
// import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
// import DialogTitle from '@material-ui/core/DialogTitle'
// import DialogContent from '@material-ui/core/DialogContent'
// import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
// import Grid from '@material-ui/core/Grid'

// import CloudUploadIcon from '@material-ui/icons/CloudUpload'
// import CancelIcon from '@material-ui/icons/Cancel'
import LockIcon from '@material-ui/icons/Lock'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  wrapper: (styles) => ({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: styles.publishing ? 'flex' : 'none',
    zIndex: 1 // need to give it a zIndex because the textbox labels pop through otherwise
  }),
  messagePanel: {
    flex: 0.5,
    maxWidth: 440
  },
  header: {
    '& span': {
      fontSize: 20,
      fontWeight: 500
    }
  }
})

export default function PublishingPanel (props) {
  const {
    publishing
  } = props

  const classes = useStyles({ publishing })

  // we are simulating a dialog here, but we can't use the normal dialog because we don't want the background to cover the whole page, just the div the panel
  // is contained within, to allow users to navigate to other parts of the Portal even though Hotkey editing is temporarily disabled
  return (
    <Box className={classes.wrapper} justifyContent="center" alignItems="center">
      <Box className={classes.messagePanel}>
        <Card variant="outlined">
          <CardHeader className={classes.header} title="Publishing Hotkeys" />
          <Divider />
          <CardContent>
            <Box display="flex">
              <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <LockIcon fontSize="large" />
              </Box>
              <Box flex={4} marginLeft={2}>
                <Typography>Publishing of Hotkeys in progress. Editing will be locked during this process. It should only take a few seconds.</Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
}

PublishingPanel.propTypes = {
  publishing: PropTypes.bool.isRequired
}
